import { useLanguage } from "@tlc/ls2pac/components/Language";
import { EResourceCheckoutResponse } from "./DownloadableCheckoutDialog";
import { useMemo } from "react";
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { DialogWithDataProps } from "@tlc/ui/dialog/useDialog";

interface AutoSyncSuccessDialogProps
  extends DialogWithDataProps<EResourceCheckoutResponse> {}
export const AutoSyncSuccessDialog = ({
  open,
  onClose,
  data: response,
}: AutoSyncSuccessDialogProps) => {
  const { translate } = useLanguage();

  const formatDisplayName = useMemo(() => {
    if (!response?.formatServiceToken) {
      return null;
    }
    const token = response.formatServiceToken
      .replace(/</g, "")
      .replace(/>/g, "");
    return translate(token);
  }, [response]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{translate("eResourceAutoSyncTitle")}</DialogTitle>
      <DialogContent>
        <Stack gap={1}>
          <Typography>
            {translate("eResourceCheckYour")} {formatDisplayName}{" "}
            {translate("eResourceSyncToAccount")}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant={"contained"} onClick={onClose}>
          {translate("ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
